import ExclamationSvg from "assets/landing/icons/ExclamantionSvg";
import exclamationIcon from "../../../../../assets/landing/exclamantion-icon.svg";
import { useEffect, useRef, useState } from "react";
import { useAnimation, useInView, motion } from "framer-motion";
import mainCardsImg from "../../../../../assets/images/cardPage/MainCardsImg.webp";
import HandDrawnCircle from "../HandDrawnCircle/HandDrawnCircle";
import { AcceleratedByCard } from "../AcceleratedBy";
import arrowDownIcon from "../../../../../assets/landing/plusicon.svg";
import { CardFormModal } from "../CardFormModal";
import { CtaUnderline } from "../../../../../assets/svgComponents/CtaUnderline";
import CardHero1DesktopUnderline from "assets/svgComponents/CardHero1DesktopUnderline";
import CardHero1MobUnderline from "assets/svgComponents/CardHero1MobUnderline";
import CardHero2MobUnderline from "assets/svgComponents/CardHero2MobUnderline";
import CardHero3MobUnderline from "assets/svgComponents/CardHero3MobUnderline";
import CardHero2DesktopUnderline from "assets/svgComponents/CardHero2DesktopUnderline";

export const CardHeroSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const controls = useAnimation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <>
      <motion.section
        ref={ref}
        initial="hidden"
        animate={controls}
        variants={containerVariants}
        className="lg:pt-[81px] max-lg:mb-[18.66] mb-[4.142vw] lg:min-h-[calc(100vh-4.93vw-32px-81px-30px-58px)] pb-[5.142vw]"
      >
        <div className="max-lg:px-[3.2vw] px-[4.58vw] w-full flex lg:min-h-[calc(100vh-4.93vw-32px-81px-30px-58px)] flex-col justify-between relative">
          <div>
            {" "}
            <motion.div
              className="absolute z-[1]  max-lg:w-full lg:top-0 max-lg:top-[59vw] md:top-[66vw]  right-[4vw] max-lg:right-0 pr-[4.58vw]  rounded-[12px] 
             bg-transparent w-[48.19vw] "
              variants={cardVariants}
            >
              <img
                className=" relative z-10 w-[48.19vw] max-lg:left-[5vw] max-lg:w-[90vw] h-auto"
                src={mainCardsImg}
                alt=""
              />

              <div className="absolute w-[52.06vw] max-lg:w-full top-[2.3vw] right-[1vw] max-lg:right-0">
                <HandDrawnCircle controls={controls} duration={2} delay={0.4} />
              </div>
            </motion.div>
            <motion.div
              className=" mb-[84vw] max-lg:px-[3.2vw] lg:mb-[2.2vw]"
              variants={textVariants}
            >
              <div className="flex flex-col gap-[1.142vw]  max-lg:justify-center mb-[32px] max-lg:mb-[6vw]">
                {" "}
                {/* <h1 className="font-medium flex  font-luxora-medium z-10 text-[15.5vw] lg:text-[6.07vw] leading-[1.1] text-black">
               
                  <span>
                    <img
                      src={exclamationIcon}
                      className="w-[10.2vw] h-auto lg:hidden"
                      alt="decoration Exclamation element"
                    />
                    <span className="max-lg:hidden block">
                      <ExclamationSvg />
                    </span>
                  </span>
                </h1> */}
                <p className="font-normal max-lg:hidden z-10 font-luxora-regular max-lg:text-[8.5vw] text-[3.3vw] leading-[1.1] text-black">
                  AGNT Neo3 Cards <br className="lg:hidden" /> turn{" "}
                  <br className="max-lg:hidden" />
                  <div className="inline relative ">
                    <span className="z-10 relative">X-native activity</span>
                    <CardHero1DesktopUnderline
                      className="absolute bottom-[-5%] left-[49%] -translate-x-1/2 z-[0] pointer-events-none
                     w-[25.8vw] "
                    />
                  </div>{" "}
                  <br className="lg:hidden" /> into{" "}
                  <br className="max-lg:hidden" />
                  <div className="inline relative ">
                    <span className="z-10 relative"> real-world checkout.</span>
                    <CardHero2DesktopUnderline
                      className="absolute bottom-[-5%] left-[49%] -translate-x-1/2 z-[0] pointer-events-none
                       w-[31.8vw] "
                    />
                  </div>{" "}
                </p>
                <p className="font-normal lg:hidden z-10 font-luxora-regular max-lg:text-[8.5vw] text-[3.3vw] leading-[1.1] text-black">
                  AGNT Neo3 Cards <br className="lg:hidden" /> turn{" "}
                  <br className="max-lg:hidden" />
                  <div className="inline relative ">
                    <span className="z-10 relative">X-native activity</span>
                    <CardHero1MobUnderline
                      className="absolute bottom-[-5%] left-[49%] -translate-x-1/2 z-[0] pointer-events-none
                       w-[65.8vw] "
                    />
                  </div>
                  <br className="lg:hidden" /> into{" "}
                  <br className="max-lg:hidden" />
                  <div className="inline relative ">
                    <span className="z-10 relative">real-world</span>
                    <CardHero2MobUnderline
                      className="absolute bottom-[-5%] left-[49%] -translate-x-1/2 z-[0] pointer-events-none
                       w-[43.8vw] "
                    />
                  </div>
                  <br className="lg:hidden" />{" "}
                  <div className="inline relative ">
                    <span className="z-10 relative">checkout.</span>
                    <CardHero3MobUnderline
                      className="absolute -bottom-[1%] left-[49%] -translate-x-1/2 z-[0] pointer-events-none
                       w-[39.8vw] "
                    />
                  </div>
                </p>
              </div>

              <button
                type="submit"
                className="h-[3.9vw] mt-auto pr-[0.7vw] flex items-center pl-[1.5vw] justify-between 
               gap-[1.142vw] install-agnt justify-center !rounded-[1.11vw]

               max-lg:w-[57.6vw] max-lg:h-[12.8vw] 
               max-lg:pr-[2.1333vw] max-lg:pl-[4.2667vw]
               max-lg:gap-[3.2vw] max-lg:!rounded-[3.2vw]"
                onClick={() => {
                  setIsModalOpen(true);
                }}
              >
                <span
                  className="text-white font-luxora-medium leading-[1.1] text-[1.39vw] font-normal 
               max-lg:text-[4.2695vw]"
                >
                  Join Waitlist
                </span>
                <div
                  className="size-[2.85vw] rounded-[0.65vw] flex items-center justify-center bg-white shadow-custom
                      max-lg:size-[8.5333vw] max-lg:rounded-[3.2vw]"
                >
                  <img
                    src={arrowDownIcon}
                    alt="arrow down"
                    className="size-[1.7vw] max-lg:size-[4.75vw]"
                  />
                </div>
              </button>
            </motion.div>
          </div>

          <motion.div className="flex items-start " variants={textVariants}>
            <AcceleratedByCard />
          </motion.div>
        </div>
      </motion.section>

      <CardFormModal
        onClose={() => setIsModalOpen(false)}
        isModalOpen={isModalOpen}
      />
    </>
  );
};
